import * as React from 'react';
import { NextPage } from 'next';
import { Layout } from '../src/components/Layout/';

const Page: NextPage = () => {
  const site = {
    title: `About`,
    header: 'TBA',
    // description: 'Discover lit events.',
  };
  return (
    <Layout data={site}>
      <div className={'pv4 relative'}>
        <div className="mw8 ml4-ns ">
          <img src="/static/images/tba-strip-basic.png" />
          {/* <img className="w-10-ns w-14" src="/static/images/tba-strip.svg" /> */}
          {/* <div
        className="relative db overflow-hidden"
        style={{ zIndex: 10, top: 0, left: 0 }}
      >
        <video autoPlay loop className="sc-1fs7h0j-7 w-60">
          <source
            data-src="https://dice-media.imgix.net/videos/homepagecover.3b7f329175c1ef6acc9454ae7eb83ac0.mp4"
            data-mobsrc="https://dice-media.imgix.net/videos/homepagecover-mobile.b7dd4a81a84fc704231f356251e7b5f0.mp4"
            src="https://dice-media.imgix.net/videos/homepagecover.3b7f329175c1ef6acc9454ae7eb83ac0.mp4"
          />
        </video>
      </div> */}

          <h2 className="f2-ns f3 font-bold mv4">
            TBA is the world's first offer-based ticketing platform that utilizes integrated technology to create &
            connect people to events in every major city with ease.
          </h2>
          <h2 className="f2-ns f3 font-bold mv4">
            However, TBA is more than a ticket. It’s a door to safe and inclusive spaces. It’s a platform to discover
            new and interesting pockets of culture. It's an entrance to unique events, curated with you in mind at just
            a click of a button.
          </h2>
          <h2 className="f2-ns f3  font-bold">
            Because we know that you can get a ticket anywhere. But here, through collaborating with venues, artists,
            and producers that center community and push cultural boundaries, you get access to experiences that
            activate you.
          </h2>
        </div>
      </div>
    </Layout>
  );
};
export default Page;
